// extracted by mini-css-extract-plugin
export var lg = "_3y-4";
export var md = "_3y-3";
export var sm = "_3y-2";
export var xs = "_3y-1";
export var xxs = "_3y-0";